function g(a, e = {}) {
  const i = {
    ...e,
    ...a
  }, {
    ariaControls: r,
    ariaDescribedBy: d,
    ariaExpanded: l,
    ariaLabel: s,
    ariaLabelledBy: o,
    autoFocus: t,
    id: n,
    isChecked: c,
    isDefaultChecked: b,
    isDisabled: u = !1,
    isInvalid: h = !1,
    isRequired: f,
    name: p,
    onChange: v,
    onClick: C,
    value: k,
    ...m
  } = i;
  return { ...{
    "aria-controls": r,
    "aria-describedby": d || void 0,
    "aria-expanded": l,
    "aria-invalid": h || void 0,
    "aria-label": s,
    "aria-labelledby": o,
    "aria-required": f || void 0,
    autoFocus: t,
    id: n,
    checked: c,
    defaultChecked: b,
    disabled: u,
    name: p,
    onChange: v,
    onClick: C,
    value: k
  }, ...m };
}
export {
  g as useFormToggleProps
};
